/* ============================================================
   Malcriados PDP — Lógica de UI dinámica
   - Volume tiers clickeables: cambian quantity del form + precio del botón
   - Manga checkbox: agrega producto addon al carrito post-add
   - Precio del botón se actualiza con: variante × qty + manga
   ============================================================ */

(function () {
  'use strict';

  function pedidoId() {
    return 'mc_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
  }

  function formatCLP(cents) {
    const n = Math.round(cents / 100);
    return '$' + n.toLocaleString('es-CL');
  }

  // -------- Lectura de selectores --------
  function getVolumeState(productInfo) {
    const block = productInfo.querySelector('[data-mc-volume]');
    if (!block) return { qty: 1, discount: 0 };
    const checked = block.querySelector('input[type="radio"]:checked');
    if (!checked) return { qty: 1, discount: 0 };
    return {
      qty: parseInt(checked.dataset.qty, 10),
      discount: parseInt(checked.dataset.discount || '0', 10),
    };
  }

  function getCurrentVariantPrice(productInfo) {
    // Lee del store de Dawn product-info, o del block de price renderizado
    const priceEl = productInfo.querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular');
    if (!priceEl) return 0;
    const txt = priceEl.textContent.trim();
    // Formato CLP "$15.000" → 1500000 cents
    const num = parseInt(txt.replace(/[^0-9]/g, ''), 10);
    return isNaN(num) ? 0 : num * 100;
  }

  // -------- Recalcular y mostrar precio total --------
  // Sync del quantity input + sticky CTA. El cálculo del total real lo
  // hace updateTotal() en initDynamicPricing(). Esta función ahora solo
  // sincroniza la quantity de Dawn con el tier seleccionado.
  function recalcular(productInfo) {
    const volume = getVolumeState(productInfo);
    const variantPrice = getCurrentVariantPrice(productInfo);
    const subtotal = variantPrice * volume.qty;
    const descuento = subtotal * (volume.discount / 100);
    actualizarStickyPrecio(subtotal - descuento);

    // Sync quantity input del form
    const qtyInput = productInfo.querySelector('input[name="quantity"]');
    if (qtyInput) {
      qtyInput.value = volume.qty;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function actualizarStickyPrecio(totalCents) {
    const sticky = document.querySelector('.mc-sticky-cta__price');
    if (!sticky || totalCents <= 0) return;
    sticky.textContent = formatCLP(totalCents);
  }

  // -------- Activación visual de tiers + emisión de evento global --------
  function activarTier(block, value) {
    block.querySelectorAll('.mc-tiercards__card').forEach((lbl) => {
      const input = lbl.querySelector('input');
      lbl.classList.toggle('is-active', input && input.value === String(value));
    });
    // Emitir evento global para que gifts unlocked y prendas_config reaccionen
    document.dispatchEvent(new CustomEvent('mc:tier:change', {
      detail: { tier: parseInt(value, 10) }
    }));
  }

  // -------- Cache handle -> variant ID --------
  const handleCache = {};
  async function handleToVariantId(handle) {
    if (handleCache[handle]) return handleCache[handle];
    try {
      const res = await fetch('/products/' + handle + '.js');
      if (!res.ok) return null;
      const data = await res.json();
      const id = data.variants && data.variants[0] && data.variants[0].id;
      if (id) handleCache[handle] = id;
      return id;
    } catch (err) {
      console.error('[Malcriados] error fetching addon ' + handle, err);
      return null;
    }
  }

  // -------- Init por instancia --------
  function init(productInfo) {
    if (!productInfo || productInfo.dataset.mcInit === '1') return;
    productInfo.dataset.mcInit = '1';

    // Volume tiers click → recalcular + activar visual
    const volBlock = productInfo.querySelector('[data-mc-volume]');
    if (volBlock) {
      volBlock.addEventListener('change', (e) => {
        if (e.target.matches('input[type="radio"]')) {
          activarTier(volBlock, e.target.value);
          recalcular(productInfo);
        }
      });
    }

    // Cambio de variante → recalcular precio (Dawn dispara variant:change)
    productInfo.addEventListener('variant:change', () => {
      setTimeout(() => recalcular(productInfo), 80);
    });

    // Init
    recalcular(productInfo);

    // Interceptar form para agregar manga después
    const form = productInfo.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    let currentPedidoId = pedidoId();

    function injectarPedidoId() {
      form.querySelectorAll('input[name="properties[__mc_pedido_id]"]').forEach((i) => i.remove());
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[__mc_pedido_id]';
      input.value = currentPedidoId;
      form.appendChild(input);
    }
    injectarPedidoId();

    // Guardamos el productInfo y currentPedidoId en data attrs para que
    // el listener global (document-level) pueda recuperarlos.
    productInfo.__mcPedidoIdRef = () => currentPedidoId;
    productInfo.__mcSetPedidoId = (id) => { currentPedidoId = id; };
    productInfo.__mcInjectarPedidoId = injectarPedidoId;

    // INTERCEPTOR SECUNDARIO: form submit en capture (defensa para Enter)
    form.addEventListener('submit', (ev) => {
      // En PDP de pack, el pack tiene su propio handler. No interceptar.
      if (productInfo.hasAttribute('data-mc-pack-pdp')) return;
      const hasPconfig = !!productInfo.querySelector('[data-mc-pconfig]');
      if (!hasPconfig) return; // sin pconfig, flow Dawn normal
      ev.preventDefault();
      ev.stopPropagation();
      ev.stopImmediatePropagation();
      const tier = getCurrentTier(productInfo);
      handleMultiPrendaSubmit(productInfo, currentPedidoId, tier).then(() => {
        currentPedidoId = pedidoId();
        injectarPedidoId();
      });
      return false;
    }, true);
  }

  // INTERCEPTOR GLOBAL en document (capture phase). Esto corre ANTES que
  // cualquier listener element-level, sin importar qué hayan hecho apps
  // de terceros (Fast Simon, upsell apps, etc.) con el botón submit.
  // Solo se registra UNA vez por carga de página.
  let __mcGlobalSubmitInterceptorBound = false;
  function bindGlobalSubmitInterceptor() {
    if (__mcGlobalSubmitInterceptorBound) return;
    __mcGlobalSubmitInterceptorBound = true;

    document.addEventListener('click', (e) => {
      // Buscar si el click fue en un botón submit del form de cart-add
      const submitBtn = e.target.closest('[type="submit"], .product-form__submit');
      if (!submitBtn) return;
      const form = submitBtn.closest('form[action*="/cart/add"]');
      if (!form) return;
      const productInfo = form.closest('product-info');
      if (!productInfo) return;
      // En PDP de pack, el pack tiene su propio handler. No interceptar.
      if (productInfo.hasAttribute('data-mc-pack-pdp')) return;
      const hasPconfig = !!productInfo.querySelector('[data-mc-pconfig]');
      if (!hasPconfig) return; // sin pconfig, dejar pasar al flow Dawn

      // Bloquear TODO: el click no llega al botón ni al form
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Loading state visual: spinner + texto "Agregando..." + disabled
      // para evitar que el cliente apriete el botón varias veces.
      setSubmitBtnLoading(submitBtn, true);

      // Recuperar el ref del pedidoId que init() guardó
      const tier = getCurrentTier(productInfo);
      const pedidoIdRef = productInfo.__mcPedidoIdRef ? productInfo.__mcPedidoIdRef() : pedidoId();

      handleMultiPrendaSubmit(productInfo, pedidoIdRef, tier)
        .then(() => {
          if (productInfo.__mcSetPedidoId) productInfo.__mcSetPedidoId(pedidoId());
          if (productInfo.__mcInjectarPedidoId) productInfo.__mcInjectarPedidoId();
        })
        .finally(() => {
          setSubmitBtnLoading(submitBtn, false);
        });
      return false;
    }, { capture: true });
  }

  // Loading state del botón "Agregar al carrito".
  function setSubmitBtnLoading(btn, isLoading) {
    if (!btn) return;
    if (isLoading) {
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('mc-btn-loading');
      // Guardar texto original y reemplazar por "Agregando..."
      const txtSpan = btn.querySelector('span:not(.svg-wrapper):not(.icon-wrap)') || btn;
      if (!btn.dataset.mcOriginalText) {
        btn.dataset.mcOriginalText = txtSpan.textContent.trim();
      }
      // Cambiar solo el text node directo, no anidados
      const directText = Array.from(txtSpan.childNodes).find((n) => n.nodeType === 3);
      if (directText) {
        if (!btn.dataset.mcOriginalDirectText) {
          btn.dataset.mcOriginalDirectText = directText.textContent;
        }
        directText.textContent = 'Agregando...';
      }
    } else {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('mc-btn-loading');
      const txtSpan = btn.querySelector('span:not(.svg-wrapper):not(.icon-wrap)') || btn;
      const directText = Array.from(txtSpan.childNodes).find((n) => n.nodeType === 3);
      if (directText && btn.dataset.mcOriginalDirectText) {
        directText.textContent = btn.dataset.mcOriginalDirectText;
      }
    }
  }

  // -------- Tier > 1: construir N line items con cada config de prenda --------
  function getCurrentTier(productInfo) {
    const tierBlock = productInfo.querySelector('[data-mc-volume]');
    if (!tierBlock) return 1;
    const checked = tierBlock.querySelector('input[type="radio"]:checked');
    if (!checked) return 1;
    return parseInt(checked.dataset.qty || checked.value, 10) || 1;
  }

  function getRetratosValue(productInfo) {
    const cardsBlock = productInfo.querySelector('[data-mc-retratos-cards]');
    if (!cardsBlock) return null;
    const checked = cardsBlock.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  function getPrendaConfig(productInfo, slotNum) {
    const pconfig = productInfo.querySelector('[data-mc-pconfig]');
    if (!pconfig) return {};
    const slot = pconfig.querySelector('.mc-pconfig__slot[data-slot="' + slotNum + '"]');
    if (!slot) return {};
    const config = {};
    slot.querySelectorAll('.mc-pconfig__option').forEach((opt) => {
      const optName = opt.dataset.optionName;
      const checked = opt.querySelector('input[type="radio"]:checked');
      if (optName && checked) config[optName] = checked.value;
    });
    return config;
  }

  // Cache de product data. Optimización: si el PDP tiene el JSON local
  // de variantes (script[data-mc-variants-json]) + data-product-options,
  // armamos productData de ahí SIN hacer fetch al server. Ahorra
  // 100-300ms en el flujo de add-to-cart.
  let productDataCache = null;
  async function getProductData(productHandle, productInfo) {
    // 1. Intentar construir desde JSON local del PDP (ultra rápido)
    if (productInfo) {
      const pconfig = productInfo.querySelector('[data-mc-pconfig]');
      const optsAttr = pconfig && pconfig.dataset.productOptions;
      const jsonScript = document.querySelector('script[data-mc-variants-json]');
      if (pconfig && optsAttr && jsonScript) {
        try {
          const optionNames = optsAttr.split('|').filter(Boolean);
          const variants = JSON.parse(jsonScript.textContent.trim());
          if (optionNames.length && Array.isArray(variants) && variants.length) {
            return {
              handle: productHandle,
              options: optionNames,
              variants: variants,
            };
          }
        } catch (e) { /* fallback al fetch */ }
      }
    }
    // 2. Fallback: cache en memoria + fetch
    if (productDataCache && productDataCache.handle === productHandle) {
      return productDataCache;
    }
    const res = await fetch('/products/' + productHandle + '.js');
    if (!res.ok) throw new Error('No se pudo cargar el producto');
    productDataCache = await res.json();
    return productDataCache;
  }

  // Regex de combining diacritical marks: usamos string con escape \u
  // para evitar cualquier problema de encoding del archivo. El rango
  // U+0300 a U+036F cubre todos los acentos combinables.
  var DIACRITICS_RE = new RegExp('[\\u0300-\\u036f]', 'g');

  function normStr(s) {
    if (s == null) return '';
    return String(s)
      .normalize('NFD')
      .replace(DIACRITICS_RE, '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  // /products/handle.js puede retornar options como array de strings
  // ['Retratos', 'Color', 'Talla'] O como array de objects
  // [{name:'Retratos', position:1, values:[...]}]. Esta función
  // normaliza al formato de strings.
  function getOptionNames(productData) {
    return (productData.options || []).map((o) => {
      if (typeof o === 'string') return o;
      if (o && typeof o === 'object' && o.name) return o.name;
      return '';
    });
  }

  function findVariantInData(productData, optionsObj) {
    const optNames = getOptionNames(productData);
    const normCfg = {};
    Object.keys(optionsObj).forEach((k) => {
      normCfg[normStr(k)] = optionsObj[k];
    });

    return productData.variants.find((v) => {
      return optNames.every((optName, idx) => {
        const key = normStr(optName);
        const expected = normCfg[key];
        const actual = v['option' + (idx + 1)];
        if (expected == null) return true;
        return normStr(actual) === normStr(expected);
      });
    });
  }

  // ============================================================
  // VINCULACIÓN DE PACKS EN EL CARRITO
  // La lógica del cart drawer (cache, decorate, remove interceptor)
  // se movió a malcriados-cart.js (cargado globalmente desde
  // theme.liquid) para que el diseño funcione en CUALQUIER página
  // donde abra el drawer, no solo el PDP.
  // Wrappers locales que llaman a window.MalcriadosCart:
  // ============================================================
  function refreshCartCache() {
    if (window.MalcriadosCart && window.MalcriadosCart.refreshCache) {
      return window.MalcriadosCart.refreshCache();
    }
    return Promise.resolve();
  }
  function decorateCartLines() {
    if (window.MalcriadosCart && window.MalcriadosCart.decorate) {
      window.MalcriadosCart.decorate();
    }
  }
  function updateCartIconBubble(sections) {
    if (window.MalcriadosCart && window.MalcriadosCart.updateIconBubble) {
      window.MalcriadosCart.updateIconBubble(sections);
    }
  }

  async function handleMultiPrendaSubmit(productInfo, mainPedidoId, tier) {
    const productHandle = (function () {
      const url = productInfo.dataset.url || window.location.pathname;
      const m = url.match(/\/products\/([^/?]+)/);
      return m ? m[1] : null;
    })();
    if (!productHandle) {
      console.error('[Malcriados] no se pudo determinar el handle del producto');
      return;
    }

    let productData;
    try {
      productData = await getProductData(productHandle, productInfo);
    } catch (e) {
      showCartError(productInfo, 'No pudimos cargar la información del producto.', 'Recarga la página y prueba de nuevo.');
      return;
    }

    // Normalizar option names (la API puede retornar objetos o strings)
    const optNames = getOptionNames(productData);

    // Determinar el nombre de la opción de retratos: primero leer del
    // data-retratos-position que el liquid del block ya expone (más
    // confiable que adivinar con regex). Fallback a regex.
    let retratosOptName;
    const retratosBlock = productInfo.querySelector('[data-mc-retratos-cards]');
    if (retratosBlock && retratosBlock.dataset.retratosPosition) {
      const pos = parseInt(retratosBlock.dataset.retratosPosition, 10);
      if (pos > 0 && optNames[pos - 1]) {
        retratosOptName = optNames[pos - 1];
      }
    }
    if (!retratosOptName) {
      retratosOptName = optNames.find((o) => /retrato|cara/i.test(o));
    }

    const retratosValue = getRetratosValue(productInfo);
    const items = [];

    let mangaCount = 0;
    let mangaAddonHandle = null;

    // Leer la fecha estimada de entrega que el bloque mc_lead_time inyectó
    // como input hidden en el form. Esto viaja como line item property
    // visible "Llega entre" para que el cliente y el equipo de Malcriados
    // la vean en cart drawer, checkout y correo de confirmación.
    // El flow tradicional (sin pconfig) ya pasa esta property vía FormData
    // del form; este flow custom (multi-prenda) la pasa explícitamente.
    const leadTimeInput = productInfo.querySelector('form[action*="/cart/add"] input[name="properties[Llega entre]"]');
    const leadTimeValue = leadTimeInput ? leadTimeInput.value : '';

    for (let n = 1; n <= tier; n++) {
      const cfg = getPrendaConfig(productInfo, n);
      if (retratosOptName && retratosValue) cfg[retratosOptName] = retratosValue;

      const variant = findVariantInData(productData, cfg);
      if (!variant) {
        console.error('[Malcriados] variante no encontrada para prenda ' + n, {
          cfgBuscado: cfg,
          productOptions: optNames,
          primeras3Variantes: productData.variants.slice(0, 3).map(v => ({
            id: v.id,
            title: v.title,
            option1: v.option1,
            option2: v.option2,
            option3: v.option3,
          })),
        });
        showCartError(productInfo, 'No encontramos una de las combinaciones que elegiste.', 'Revisa color y talla en cada prenda y vuelve a intentar.');
        return;
      }
      // Validar stock: si la variante existe pero no está disponible,
      // bloquear el add y dar feedback específico (color/talla agotada).
      if (variant.available === false) {
        console.warn('[Malcriados] variante sin stock para prenda ' + n, variant.title);
        showCartError(productInfo, 'La prenda ' + n + ' está agotada.', variant.title + ' no tiene stock. Elige otro color o talla.');
        return;
      }
      const prendaProps = {
        __mc_pedido_id: mainPedidoId,
        __mc_pack_id: mainPedidoId,
        __mc_pack_total: String(tier),
        __mc_pack_pos: String(n),
      };
      // Fecha estimada de entrega (visible en cart/checkout/email).
      // Solo se agrega a las prendas, NO a los extras (jockey, manga, etc.).
      if (leadTimeValue) {
        prendaProps['Llega entre'] = leadTimeValue;
      }
      // Tier >= 2: marcar grupo para que la Shopify Function aplique el
      // descuento por volumen. mainPedidoId es único por submit y agrupa
      // las N prendas del mismo tier click. Si el cliente edita y rompe
      // el grupo, la function quita el descuento automáticamente.
      if (tier >= 2) {
        prendaProps._mc_tier_group = mainPedidoId;
        prendaProps._mc_tier_qty = String(tier);
      }
      items.push({
        id: variant.id,
        quantity: 1,
        properties: prendaProps,
      });

      // Extras checkeados de ESTA prenda específica. Cada extra activado
      // se agregará como line item separado, vinculado a la prenda via
      // __mc_pack_id + __mc_extra_for_pos.
      const slot = productInfo.querySelector('.mc-pconfig__slot[data-slot="' + n + '"]');
      if (slot) {
        const extraInputs = slot.querySelectorAll('[data-mc-extra-slot] input[type="checkbox"]:checked');
        for (const extraInput of extraInputs) {
          const extraTitle = extraInput.dataset.extraTitle || 'Extra';
          const extraId = extraInput.dataset.extraId;
          // Preferir el variant ID directo (del product picker en liquid).
          // Fallback: resolver el handle via /products/handle.js si falta.
          let extraVariantId = parseInt(extraInput.dataset.addonVariantId, 10);
          if (!extraVariantId || isNaN(extraVariantId)) {
            const extraHandle = extraInput.dataset.addonHandle;
            if (!extraHandle) continue;
            try {
              extraVariantId = await handleToVariantId(extraHandle);
            } catch (extraErr) {
              console.error('[Malcriados] error resolviendo extra handle ' + extraHandle, extraErr);
              continue;
            }
          }
          // Si el extra tiene multiples variantes (ej. jockey con colores),
          // usar la que el cliente eligio en el <select> inline.
          const extraLabel = extraInput.closest('.mc-pconfig__extra');
          const variantSel = extraLabel && extraLabel.querySelector('[data-mc-extra-variant-select]');
          if (variantSel && variantSel.value) {
            const selectedVariantId = parseInt(variantSel.value, 10);
            if (selectedVariantId && !isNaN(selectedVariantId)) {
              extraVariantId = selectedVariantId;
            }
          }
          if (extraVariantId) {
            const extraDiscountClp = parseInt(extraInput.dataset.extraDiscountClp || '0', 10);
            const extraProps = {
              __mc_pedido_id: mainPedidoId,
              __mc_pack_id: mainPedidoId,
              __mc_extra_for_pos: String(n), // vinculado a prenda N
              __mc_extra_id: extraId,
              __mc_tipo: 'extra',
              // Property visible al cliente en el carrito
              'Para prenda': String(n),
            };
            // Si el metaobject mc_extra tiene descuento upsell > 0,
            // lo pasamos como property para que la Shopify Function
            // lo aplique al checkout. Sin esto, paga precio normal.
            if (extraDiscountClp > 0) {
              extraProps._mc_extra_discount_clp = String(extraDiscountClp);
            }
            items.push({
              id: extraVariantId,
              quantity: 1,
              properties: extraProps,
            });
          }
        }
      }
    }

    // PRE-VALIDACIÓN DE STOCK por duplicados:
    // si dos slots eligieron la misma variante (mismo color/talla/retratos)
    // pero solo hay 1 unidad en inventario, abortar antes del fetch con
    // un mensaje claro al cliente.
    const stockError = validateStockForItems(productData, items);
    if (stockError) {
      showCartError(productInfo, stockError.title, stockError.text);
      return;
    }

    // Pedir TODAS las secciones que pueda necesitar el cart UI del theme.
    // Si la sección no existe, Shopify simplemente la omite del response.
    const sectionsToRender = [
      'cart-drawer',
      'cart-notification-product',
      'cart-notification-button',
      'cart-icon-bubble',
    ];
    const body = {
      items,
      sections: sectionsToRender.join(','),
      sections_url: window.location.pathname,
    };

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      if (!res.ok) {
        const errBody = await res.text();
        console.error('[Malcriados] cart add response no-ok:', res.status, errBody);
        // Parsear mensaje del servidor para mostrar feedback útil al cliente
        let serverMsg = '';
        try {
          const errJson = JSON.parse(errBody);
          serverMsg = errJson.description || errJson.message || '';
        } catch (e) {}
        const err = new Error('cart add failed: ' + res.status);
        err.status = res.status;
        err.serverMessage = serverMsg;
        throw err;
      }
      const cartResp = await res.json();
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      // OPTIMIZACIÓN VELOCIDAD: refrescar el cache del cart EN PARALELO
      // con el render del drawer. No bloqueamos la UI esperando /cart.js.
      // El render visual usa cartResp.sections (ya tenemos el HTML).
      // El cache se actualiza en background y decorateCartLines corre
      // cuando termine el fetch.
      const cachePromise = refreshCartCache();

      // Renderizar y abrir el cart UI (drawer o notification según theme).
      // Re-querear DESPUÉS del add por si el theme inicializa el drawer
      // dinámicamente (lazy load por apps de terceros).
      const cartUI = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      // SIEMPRE refrescar el bubble del header primero (cuenta del carrito)
      updateCartIconBubble(cartResp.sections);

      // /cart/add.js con multi-items puede retornar:
      //   { items: [{key, id, ...}, ...], sections: {...} }
      //   O para single item: { key, id, ..., sections: {...} }
      // Usamos el último item como representativo para la notification.
      const cartItems = cartResp.items || (cartResp.id ? [cartResp] : []);
      const lastItem = cartItems[cartItems.length - 1] || {};

      // Render del cart UI: intentar renderContents nativo + ALWAYS hacer
      // fetch fresh del cart-drawer y reemplazar contenido. La doble pasada
      // garantiza que vemos los items aunque /cart/add.js haya retornado
      // HTML stale o vacío por interferencia de apps de terceros (Fast
      // Simon Bundles inyecta cosas raras al rendering).
      // OPTIMIZACIÓN VELOCIDAD: usamos directamente cartResp.sections
      // del primer /cart/add.js. NO hacemos un segundo fetch fresh.
      // El cart drawer se renderiza con la respuesta del add directamente.
      // Aplicamos clase mc-cart-pending-decorate al body para ocultar
      // los items con opacity 0 mientras decorate corre — evita el FOUC
      // (flash del layout viejo de Dawn antes de aplicar nuestro flex).
      document.body.classList.add('mc-cart-pending-decorate');
      // Safety timeout: si por algún motivo no se quita la clase, tras
      // 800ms se fuerza la limpieza. Garantiza que nunca quede el cart
      // invisible.
      const __mcAddFadeSafety = setTimeout(() => {
        document.body.classList.remove('mc-cart-pending-decorate');
      }, 800);
      let drawerOpened = false;
      const cartDrawerEl = document.getElementById('CartDrawer');
      if (cartDrawerEl && cartResp.sections && cartResp.sections['cart-drawer']) {
        try {
          const parsed = new DOMParser()
            .parseFromString(cartResp.sections['cart-drawer'], 'text/html')
            .querySelector('#CartDrawer');
          if (parsed) {
            cartDrawerEl.innerHTML = parsed.innerHTML;
          }
        } catch (e) { /* fallback abajo */ }
      }

      // Quitar is-empty + abrir drawer
      const cartDrawerComp = document.querySelector('cart-drawer');
      if (cartDrawerComp) {
        cartDrawerComp.classList.remove('is-empty');
        const inner = cartDrawerComp.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        if (typeof cartDrawerComp.open === 'function') {
          try { cartDrawerComp.open(); drawerOpened = true; } catch (e) {}
        }
      }

      // Esperar a que el cache esté listo (o resolverá inmediato si ya
      // terminó en paralelo) y decorar las líneas del drawer.
      try {
        await cachePromise;
        decorateCartLines();
      } catch (e) {
        console.warn('[Malcriados] decorate post-add falló:', e);
      } finally {
        // Quitar el fade-out — el cart-drawer ahora muestra los items
        // ya decorados con un fade-in suave (transition CSS).
        clearTimeout(__mcAddFadeSafety);
        requestAnimationFrame(() => {
          document.body.classList.remove('mc-cart-pending-decorate');
        });
      }

      // Si por algún motivo no se abrió el drawer, click programático
      // como último recurso.
      if (!drawerOpened) {
        const cartIcon = document.querySelector('#cart-icon-bubble');
        if (cartIcon) cartIcon.click();
      }

      // Publicar el evento de Dawn para que otros componentes se enteren
      // (cart-drawer-items, sticky-cart, etc. lo escuchan).
      try {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: items[0] && items[0].id,
            cartData: cartResp,
          });
        }
      } catch (pubErr) {
        console.warn('[Malcriados] no se pudo publicar cartUpdate:', pubErr);
      }
    } catch (err) {
      console.error('[Malcriados] error agregando pack:', err);
      let title, text;
      if (err.status === 422 && err.serverMessage && /agotad/i.test(err.serverMessage)) {
        // El JSON local tiene esta variante como available — la marcamos
        // como no disponible en memoria y re-renderizamos la UI para que
        // el cliente vea inmediatamente que ese color/talla quedó gris.
        markVariantOutOfStock(productInfo, err.serverMessage);
        title = 'Una de las prendas se agotó hace un momento.';
        text = 'Actualizamos las opciones disponibles. Elige otro color o talla y vuelve a intentar.';
      } else if (err.serverMessage) {
        title = 'No pudimos agregar al carrito.';
        text = err.serverMessage;
      } else {
        title = 'No pudimos agregar al carrito.';
        text = 'Verifica tu conexión e inténtalo de nuevo.';
      }
      showCartError(productInfo, title, text);
    }
  }

  // Muestra un banner de error inline ARRIBA del botón "Agregar al
  // carrito". Reemplaza el alert() nativo por un mensaje con estilo
  // del sistema, accesible y con auto-dismiss + botón cerrar manual.
  function showCartError(productInfo, title, text) {
    if (!productInfo) {
      alert((title ? title + ' ' : '') + (text || ''));
      return;
    }

    if (productInfo.__mcCartErrTimer) {
      clearTimeout(productInfo.__mcCartErrTimer);
      productInfo.__mcCartErrTimer = null;
    }

    let banner = productInfo.querySelector('.mc-cart-error');
    if (!banner) {
      banner = document.createElement('div');
      banner.className = 'mc-cart-error';
      banner.setAttribute('role', 'alert');
      banner.setAttribute('aria-live', 'polite');

      const icon = document.createElement('span');
      icon.className = 'mc-cart-error__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '⚠️';

      const body = document.createElement('div');
      body.className = 'mc-cart-error__body';
      const titleEl = document.createElement('span');
      titleEl.className = 'mc-cart-error__title';
      const textEl = document.createElement('span');
      textEl.className = 'mc-cart-error__text';
      body.appendChild(titleEl);
      body.appendChild(textEl);

      const closeBtn = document.createElement('button');
      closeBtn.className = 'mc-cart-error__close';
      closeBtn.type = 'button';
      closeBtn.setAttribute('aria-label', 'Cerrar mensaje');
      closeBtn.textContent = '×';
      closeBtn.addEventListener('click', () => {
        banner.remove();
        if (productInfo.__mcCartErrTimer) {
          clearTimeout(productInfo.__mcCartErrTimer);
          productInfo.__mcCartErrTimer = null;
        }
      });

      banner.appendChild(icon);
      banner.appendChild(body);
      banner.appendChild(closeBtn);

      const form = productInfo.querySelector('product-form, .product-form');
      if (form && form.parentElement) {
        form.parentElement.insertBefore(banner, form);
      } else {
        const info = productInfo.querySelector('.product__info-container') || productInfo;
        info.prepend(banner);
      }
    }

    banner.querySelector('.mc-cart-error__title').textContent = title || '';
    banner.querySelector('.mc-cart-error__text').textContent = text || '';

    try {
      const rect = banner.getBoundingClientRect();
      if (rect.top < 80 || rect.bottom > window.innerHeight) {
        banner.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    } catch (e) {}

    productInfo.__mcCartErrTimer = setTimeout(() => {
      if (banner && banner.parentElement) banner.remove();
      productInfo.__mcCartErrTimer = null;
    }, 8000);
  }

  // Pre-valida si la suma de unidades pedidas (incluyendo duplicados de
  // misma variante en distintos slots) excede el inventory_quantity.
  // Devuelve { title, text } si falla, null si todo OK.
  // Solo aplica para items con inventory tracking activo.
  function validateStockForItems(productData, items) {
    if (!productData || !productData.variants || !Array.isArray(items)) return null;

    // Contar cuántas unidades se piden por cada variant_id
    const requestedById = {};
    items.forEach((it) => {
      const id = it.id;
      requestedById[id] = (requestedById[id] || 0) + (it.quantity || 1);
    });

    // Validar contra inventory_quantity de cada variante
    for (const variantId in requestedById) {
      const requested = requestedById[variantId];
      if (requested <= 1) continue; // 1 unidad nunca falla por duplicados

      const variant = productData.variants.find((v) => String(v.id) === String(variantId));
      if (!variant) continue;

      // Si la variante no trackea inventory (inventory_management null),
      // Shopify acepta cualquier cantidad — saltar validación.
      if (!variant.inventory_management) continue;

      const stock = parseInt(variant.inventory_quantity, 10);
      if (isNaN(stock)) continue;

      if (stock < requested) {
        const remaining = stock > 0 ? stock : 0;
        const variantTitle = [variant.option1, variant.option2, variant.option3]
          .filter(Boolean)
          .join(' / ');
        if (remaining === 0) {
          return {
            title: 'Esa combinación se agotó.',
            text: variantTitle + ' no tiene stock. Cambia el color o la talla para esa prenda.',
          };
        }
        return {
          title: 'No alcanza el stock para las ' + requested + ' prendas.',
          text: 'Solo queda ' + remaining + ' unidad de ' + variantTitle + '. Elige otro color o talla para una de las prendas.',
        };
      }
    }

    return null;
  }

  // Cuando el servidor responde 422 'agotado', marcamos esa variante en
  // el JSON local como available: false y refrescamos la UI de stock
  // para que el color/talla agotado quede inmediatamente deshabilitado.
  function markVariantOutOfStock(productInfo, serverMessage) {
    if (!productInfo || !serverMessage) return;
    const jsonScript = productInfo.querySelector('script[data-mc-variants-json]');
    if (!jsonScript) return;

    let variants;
    try {
      variants = JSON.parse(jsonScript.textContent.trim());
    } catch (e) {
      return;
    }
    if (!Array.isArray(variants)) return;

    // El mensaje del server tiene formato:
    // "El artículo 'Hoodie Bordado Malcriados - 2 retratos / S / Negro' ya está agotado."
    // Extraemos el título entre comillas para hacer match.
    const match = serverMessage.match(/'([^']+)'/) || serverMessage.match(/"([^"]+)"/);
    if (!match) return;
    const variantTitle = match[1];

    // Las options del producto. Buscamos la variante que matchee con el
    // título usando los option1/option2/option3 (por concatenación
    // similar a como Shopify arma el title de variante).
    const optsAttr = (productInfo.querySelector('[data-mc-pconfig]') || {}).dataset?.productOptions || '';
    const optNames = optsAttr.split('|').filter(Boolean);

    let matched = false;
    variants.forEach((v) => {
      // Construir título posible: "option1 / option2 / option3"
      const parts = [];
      if (v.option1) parts.push(v.option1);
      if (v.option2) parts.push(v.option2);
      if (v.option3) parts.push(v.option3);
      const candidateTitle = parts.join(' / ');
      // Match exacto o que el título del server contenga el candidato
      if (
        variantTitle.includes(candidateTitle) ||
        candidateTitle === variantTitle.split(' - ').pop()
      ) {
        v.available = false;
        matched = true;
      }
    });

    if (matched) {
      jsonScript.textContent = JSON.stringify(variants);
      const pconfig = productInfo.querySelector('[data-mc-pconfig]');
      if (pconfig) updateStockUI(pconfig);
    }
  }

  // -------- Sticky CTA: aparece cuando el add-to-cart sale del viewport --------
  // En mobile barra fija arriba; en desktop botón flotante abajo-derecha.
  // Click → scroll suave a la sección de "Cantidad de retratos".
  //
  // Usamos scroll listener (en lugar de IntersectionObserver) porque el
  // observer solo se dispara cuando cambia el estado de intersección.
  // Con scroll listener evaluamos en cada cuadro, lo cual garantiza que
  // el sticky aparezca correctamente al scrollear hacia abajo desde el
  // load inicial sin esperar a que el observer "detecte" el cambio.
  function initStickyCta() {
    const sticky = document.querySelector('[data-mc-cta-sticky]');
    const btn = document.querySelector('[data-mc-cta-sticky-btn]');
    if (!sticky || !btn) return;

    const submitBtn = document.querySelector(
      '.product__info-container .product-form__submit, product-form button[type="submit"]'
    );
    const target = document.querySelector('[data-mc-retratos-cards]');

    // Si no hay botón de add-to-cart en la página, no tiene sentido el sticky.
    if (!submitBtn) return;

    sticky.hidden = false;

    function updateStickyVisibility() {
      const rect = submitBtn.getBoundingClientRect();
      // Mostrar el sticky solo cuando el cliente ya scrolleó MÁS ALLÁ del
      // botón (rect.bottom < 0 → el botón salió por arriba del viewport).
      // Si el botón aún está visible o debajo del viewport, ocultar.
      if (rect.bottom < 0) {
        sticky.classList.add('is-visible');
      } else {
        sticky.classList.remove('is-visible');
      }
    }

    let rafId = null;
    function onScrollOrResize() {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        updateStickyVisibility();
        rafId = null;
      });
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });

    // Estado inicial al cargar (por si el usuario llega con un anchor o
    // recarga la página en una posición scrolleada).
    updateStickyVisibility();
    // Re-chequear después de un breve delay porque el layout puede
    // ajustarse después del load (Loox, lazy images, fonts).
    setTimeout(updateStickyVisibility, 500);
    setTimeout(updateStickyVisibility, 1500);

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const scrollTarget = target || submitBtn;
      if (scrollTarget && typeof scrollTarget.scrollIntoView === 'function') {
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  function boot() {
    bindGlobalSubmitInterceptor();
    // bindCartRemoveInterceptor + refreshCartCache ahora en malcriados-cart.js (global)
    document.querySelectorAll('product-info').forEach(init);
    syncSideIconsHeight();
    initMainSliderArrows();
    initRetratosCards();
    initPrendasConfig();
    initTallaModal();
    initDynamicPricing();
    initTierSync();
    initLeadTime();
    // Loox carga async — múltiples intentos
    moveLooxToMedia();
    setTimeout(moveLooxToMedia, 800);
    setTimeout(moveLooxToMedia, 2000);
    // Accordion también — desktop al media-wrapper, mobile a info-column
    moveAccordionToMedia();
    setTimeout(moveAccordionToMedia, 200);
    // Accordion exclusivo — solo una pestaña abierta a la vez
    initAccordionExclusive();
    // Sticky CTA "Continúa tu pedido"
    initStickyCta();
    // Alinear alturas de subs de tier cards (dinámico) - múltiples
    // intentos por si fonts/imgs cargan después y cambian el wrap
    alignTierCardSubs();
    requestAnimationFrame(alignTierCardSubs);
    setTimeout(alignTierCardSubs, 300);
    setTimeout(alignTierCardSubs, 1000);
    // Marcar que el variant picker fue procesado (CSS revela los pickers visibles)
    document.querySelectorAll('product-info').forEach((pi) => {
      pi.classList.add('mc-pdp-vp-ready');
    });
  }

  // -------- Tier sync centralizado: un solo listener, una sola función --------
  function setTier(productInfo, tier) {
    const t = Math.max(1, Math.min(3, parseInt(tier, 10) || 1));

    // 1. Marcar la card del tier como activa
    const volBlock = productInfo.querySelector('[data-mc-volume]');
    if (volBlock) {
      volBlock.querySelectorAll('.mc-tiercards__card').forEach((card) => {
        const inp = card.querySelector('input');
        const cardTier = inp ? parseInt(inp.dataset.qty || inp.value, 10) : 0;
        card.classList.toggle('is-active', cardTier === t);
      });
    }

    // 2. Mostrar/ocultar slots del prendas_config
    const pconfig = productInfo.querySelector('[data-mc-pconfig]');
    if (pconfig) {
      pconfig.querySelectorAll('.mc-pconfig__slot').forEach((slot) => {
        const slotNum = parseInt(slot.dataset.slot, 10);
        if (slotNum <= t) {
          slot.removeAttribute('hidden');
        } else {
          slot.setAttribute('hidden', '');
        }
      });
    }

    // 3. Recalcular precios y total
    const variantPrice = readCurrentVariantPrice(productInfo);
    if (variantPrice) {
      updateTierPrices(productInfo, variantPrice);
      updateTotal(productInfo, variantPrice);
    }

    // 4. Emitir evento (para otros componentes externos que escuchen)
    document.dispatchEvent(new CustomEvent('mc:tier:change', { detail: { tier: t } }));
  }

  function initTierSync() {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      const volBlock = productInfo.querySelector('[data-mc-volume]');
      if (!volBlock || volBlock.dataset.mcSyncInit === '1') return;
      volBlock.dataset.mcSyncInit = '1';

      // Listener directo: change en el volume block dispara setTier
      volBlock.addEventListener('change', (e) => {
        if (!e.target.matches('input[type="radio"]')) return;
        const tier = parseInt(e.target.dataset.qty || e.target.value, 10) || 1;
        setTier(productInfo, tier);
      });

      // Aplicar tier inicial leyendo el radio checked
      const checked = volBlock.querySelector('input[type="radio"]:checked');
      const initialTier = checked ? (parseInt(checked.dataset.qty || checked.value, 10) || 1) : 1;
      setTier(productInfo, initialTier);
    });
  }

  // -------- Pricing dinámico: tier cards + total --------
  function initDynamicPricing() {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      if (productInfo.dataset.mcPricingInit === '1') return;
      productInfo.dataset.mcPricingInit = '1';

      const update = () => {
        const variantPrice = readCurrentVariantPrice(productInfo);
        if (!variantPrice) return;
        updateTierPrices(productInfo, variantPrice);
        updateTotal(productInfo, variantPrice);
      };

      // Init
      update();
      requestAnimationFrame(update);
      setTimeout(update, 300);

      // Variant change (Dawn dispara este evento)
      productInfo.addEventListener('variant:change', () => setTimeout(update, 50));
      productInfo.addEventListener('on:variant:change', () => setTimeout(update, 50));

      // Tier change
      document.addEventListener('mc:tier:change', () => setTimeout(update, 30));

      // Extras checkboxes (cualquier extra cambiado → recalcular total)
      productInfo.addEventListener('change', (e) => {
        if (e.target.matches('[data-mc-extra-slot] input[type="checkbox"]')) {
          update();
        }
      });

      // MutationObserver del precio (por si Dawn lo actualiza)
      const priceContainer = productInfo.querySelector('[id^="price-"]');
      if (priceContainer && typeof MutationObserver !== 'undefined') {
        new MutationObserver(() => update()).observe(priceContainer, {
          childList: true, subtree: true, characterData: true
        });
      }
    });
  }

  function readCurrentVariantPrice(productInfo) {
    // Lee el precio de la variante actualmente seleccionada (en centavos)
    const priceEl = productInfo.querySelector(
      '[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular, [id^="price-"] .price-item'
    );
    if (!priceEl) return 0;
    const txt = priceEl.textContent.trim();
    const num = parseInt(txt.replace(/[^0-9]/g, ''), 10);
    return isNaN(num) ? 0 : num * 100;
  }

  function updateTierPrices(productInfo, variantPriceCents) {
    const tierBlock = productInfo.querySelector('[data-mc-volume]');
    if (!tierBlock) return;

    const tier1 = tierBlock.querySelector('[data-tier="1"]');
    const tier2 = tierBlock.querySelector('[data-tier="2"]');
    const tier3 = tierBlock.querySelector('[data-tier="3"]');

    // % de promo visual aplicable (cyber u otra) leído del data-attr
    // que coloca el liquid. Solo se aplica al tier 1; tier 2/3 mantienen
    // su cálculo normal porque el % de volumen ya cubre la promo
    // (Diego ajusta manualmente el % del tier para reflejar el cyber).
    const cyberPct = parseInt(tierBlock.dataset.mcCyberPct || '0', 10);
    const cyberFactor = (100 - cyberPct) / 100;

    function setText(card, selector, val) {
      if (!card) return;
      const el = card.querySelector(selector);
      if (el) el.textContent = formatCLP(val);
    }
    function setDataPrice(card, val) {
      if (!card) return;
      const inp = card.querySelector('input');
      if (inp) inp.dataset.price = val;
    }

    // Tier 1: con cyber → muestra base tachado + final descontado.
    //         sin cyber → solo precio base.
    if (tier1) {
      if (cyberPct > 0) {
        const finalT1 = Math.round(variantPriceCents * cyberFactor);
        setText(tier1, '.mc-tiercards__price-was', variantPriceCents);
        setText(tier1, '.mc-tiercards__price-new', finalT1);
        setDataPrice(tier1, finalT1);
      } else {
        setText(tier1, '.mc-tiercards__price-new', variantPriceCents);
        setDataPrice(tier1, variantPriceCents);
      }
    }

    // Tier 2: × 2 con descuento de volumen (sin cyber acumulado)
    if (tier2) {
      const inp = tier2.querySelector('input');
      const pct = parseInt((inp && inp.dataset.discount) || '15', 10);
      const total = variantPriceCents * 2;
      const discAmt = Math.round(total * pct / 100);
      const final = total - discAmt;
      setText(tier2, '.mc-tiercards__price-was', total);
      setText(tier2, '.mc-tiercards__price-new', final);
      setDataPrice(tier2, final);
    }

    // Tier 3: × 3 con descuento de volumen (sin cyber acumulado)
    if (tier3) {
      const inp = tier3.querySelector('input');
      const pct = parseInt((inp && inp.dataset.discount) || '25', 10);
      const total = variantPriceCents * 3;
      const discAmt = Math.round(total * pct / 100);
      const final = total - discAmt;
      setText(tier3, '.mc-tiercards__price-was', total);
      setText(tier3, '.mc-tiercards__price-new', final);
      setDataPrice(tier3, final);
    }
  }

  function updateTotal(productInfo, variantPriceCents) {
    const totalEl = productInfo.querySelector('[data-mc-total-amount]');
    if (!totalEl) return;

    const tier = getCurrentTier(productInfo);
    const tierBlock = productInfo.querySelector('[data-mc-volume]');
    let pct = 0;
    if (tierBlock) {
      const checked = tierBlock.querySelector('input[type="radio"]:checked');
      if (checked) pct = parseInt(checked.dataset.discount || '0', 10);
    }

    // % de promo visual (cyber) leído del data-attr del fieldset de
    // tiers. Misma regla que las tier cards: aplica solo al tier 1.
    // En tier 2/3 el % de volumen ya cubre el cyber (Diego sube el
    // mc_tiers_pct a 20 manualmente durante la promo).
    const cyberPct = tierBlock ? parseInt(tierBlock.dataset.mcCyberPct || '0', 10) : 0;
    const subtotal = variantPriceCents * tier;
    let discAmt;
    if (tier === 1 && cyberPct > 0) {
      discAmt = Math.round(subtotal * cyberPct / 100);
    } else {
      discAmt = Math.round(subtotal * pct / 100);
    }
    let total = subtotal - discAmt;

    // Sumar todos los EXTRAS activos (de los slots visibles).
    // Cada checkbox de extra tiene data-extra-price con el precio en CLP
    // (no en centavos). Multiplicamos por 100 para sumarlo al total
    // que está en centavos.
    const pconfig = productInfo.querySelector('[data-mc-pconfig]');
    if (pconfig) {
      pconfig.querySelectorAll('.mc-pconfig__slot:not([hidden]) [data-mc-extra-slot] input[type="checkbox"]:checked').forEach((cb) => {
        const priceCLP = parseInt(cb.dataset.extraPrice || '0', 10);
        if (!isNaN(priceCLP)) total += priceCLP * 100;
      });
    }

    totalEl.textContent = formatCLP(total);
    totalEl.dataset.mcTotalCents = String(total);

    // Integrar el total al botón "Agregar al carrito":
    // "AGREGAR AL CARRITO · $55.000"
    updateSubmitBtnTotal(productInfo, total);
    updateCuotas(productInfo, total);
  }

  // Recalcula el monto por cuota en cada bloque [data-mc-cuotas]
  // dividiendo el total actual por data-cuotas-n. Se llama desde
  // updateTotal así queda siempre sincronizado.
  function updateCuotas(productInfo, totalCents) {
    productInfo.querySelectorAll('[data-mc-cuotas]').forEach((el) => {
      const n = parseInt(el.dataset.cuotasN || '3', 10);
      if (!n || n < 1) return;
      const perCuota = Math.round(totalCents / n);
      const amountEl = el.querySelector('[data-mc-cuotas-amount]');
      if (amountEl) amountEl.textContent = formatCLP(perCuota);
    });
  }

  // Inyecta el total al lado del texto del botón submit. La primera vez
  // crea el span; después solo actualiza textContent.
  function updateSubmitBtnTotal(productInfo, totalCents) {
    const btn = productInfo.querySelector('.product-form__submit, [type="submit"]');
    if (!btn) return;
    let totalSpan = btn.querySelector('.mc-btn-total');
    if (!totalSpan) {
      totalSpan = document.createElement('span');
      totalSpan.className = 'mc-btn-total';
      // Insertar después del primer text node (después de "Agregar al carrito")
      btn.appendChild(totalSpan);
    }
    totalSpan.textContent = '· ' + formatCLP(totalCents);
  }

  // -------- Mover widget Loox: desktop debajo de thumbs / mobile al final --------
  // BIDIRECCIONAL:
  // - Desktop (≥990px): inserta el Loox dentro del media-wrapper (grid).
  // - Mobile (<990px): lo regresa a su padre original (info-container,
  //   donde Diego lo dejó en el editor del theme).
  // - Re-corre en window resize para adaptarse al cambiar el viewport.
  let __mcLooxOriginalParent = null;
  let __mcLooxOriginalNext = null;
  let __mcLooxResizeRaf = null;

  function moveLooxToMedia() {
    const looxBlock = document.querySelector(
      '[class*="loox-snippets"], [id*="loox-snippets" i], ' +
      '[class*="loox-reviews"], [id*="loox-reviews" i], ' +
      '.product__info-container [class*="loox"], ' +
      '.product__info-container [id*="loox" i]'
    );
    if (!looxBlock) return;

    const mediaWrapper = document.querySelector('.product__media-wrapper');
    if (!mediaWrapper) return;

    const isDesktop = window.innerWidth >= 990;
    const isInMedia = mediaWrapper.contains(looxBlock);

    // Cuando el Loox está en su posición original (NO en media-wrapper),
    // guardar refs para poder volverlo si el viewport cambia a mobile.
    if (!isInMedia) {
      __mcLooxOriginalParent = looxBlock.parentElement;
      __mcLooxOriginalNext = looxBlock.nextElementSibling;
    }

    if (isDesktop && !isInMedia) {
      // → mover al media-wrapper
      looxBlock.classList.add('mc-loox-in-media');
      mediaWrapper.appendChild(looxBlock);
    } else if (!isDesktop && isInMedia) {
      // → regresar al padre original (mobile)
      looxBlock.classList.remove('mc-loox-in-media');
      if (__mcLooxOriginalParent) {
        if (__mcLooxOriginalNext && __mcLooxOriginalNext.parentElement === __mcLooxOriginalParent) {
          __mcLooxOriginalParent.insertBefore(looxBlock, __mcLooxOriginalNext);
        } else {
          __mcLooxOriginalParent.appendChild(looxBlock);
        }
      }
    }
  }

  // Re-correr en cambios de viewport
  if (typeof window !== 'undefined') {
    window.addEventListener('resize', () => {
      cancelAnimationFrame(__mcLooxResizeRaf);
      __mcLooxResizeRaf = requestAnimationFrame(() => {
        moveLooxToMedia();
        moveAccordionToMedia();
      });
    });
  }

  // -------- Mover accordion: desktop debajo del Loox / mobile al final --------
  // Mismo patrón que moveLooxToMedia.
  let __mcAccOriginalParent = null;
  let __mcAccOriginalNext = null;
  function moveAccordionToMedia() {
    const accBlock = document.querySelector('.mc-accordion');
    if (!accBlock) return;
    const mediaWrapper = document.querySelector('.product__media-wrapper');
    if (!mediaWrapper) return;

    const isDesktop = window.innerWidth >= 990;
    const isInMedia = mediaWrapper.contains(accBlock);

    if (!isInMedia) {
      __mcAccOriginalParent = accBlock.parentElement;
      __mcAccOriginalNext = accBlock.nextElementSibling;
    }

    if (isDesktop && !isInMedia) {
      accBlock.classList.add('mc-accordion--in-media');
      mediaWrapper.appendChild(accBlock);
    } else if (!isDesktop && isInMedia) {
      accBlock.classList.remove('mc-accordion--in-media');
      if (__mcAccOriginalParent) {
        if (__mcAccOriginalNext && __mcAccOriginalNext.parentElement === __mcAccOriginalParent) {
          __mcAccOriginalParent.insertBefore(accBlock, __mcAccOriginalNext);
        } else {
          __mcAccOriginalParent.appendChild(accBlock);
        }
      }
    }
  }

  // -------- Accordion exclusivo: solo una pestaña abierta a la vez --------
  // Cuando el usuario abre un <details>, cierra todos los demás del mismo
  // .mc-accordion. Idempotente: marca cada details con data-mc-acc-init
  // para no doblar listeners si se reinicia la sección desde el editor.
  //
  // Bonus UX: si al abrir un panel se cerró otro (flujo "estaba leyendo
  // el A, ahora abro el B"), hacer scroll suave al título del nuevo
  // panel para que el viewport quede alineado. Sin esto, el usuario
  // queda mostrando contenido de arriba porque el A largo colapsó.
  function initAccordionExclusive() {
    document.querySelectorAll('.mc-accordion').forEach((accBlock) => {
      const items = accBlock.querySelectorAll('details.mc-accordion__item');
      items.forEach((det) => {
        if (det.dataset.mcAccInit === '1') return;
        det.dataset.mcAccInit = '1';
        det.addEventListener('toggle', () => {
          if (!det.open) return;
          let hadOtherOpen = false;
          items.forEach((other) => {
            if (other !== det && other.open) {
              hadOtherOpen = true;
              other.open = false;
            }
          });
          // Solo scroll si hubo cierre (cambio de panel). Si abre el
          // primero o re-abre uno cerrado, no molestar al usuario.
          // Scroll al TOPE del accordion (no al panel actual) para que
          // todas las pestañas queden visibles y el usuario pueda
          // elegir otra fácilmente.
          if (hadOtherOpen) {
            requestAnimationFrame(() => {
              accBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
          }
        });
      });
    });
  }

  // -------- Tiempo de entrega dinámico --------
  const MC_REGION_LS_KEY = 'mc_user_region';
  const MC_REGION_DEFAULT = 'Metropolitana';

  function initLeadTime() {
    document.querySelectorAll('[data-mc-leadtime]').forEach((el) => {
      if (el.dataset.mcLtInit === '1') return;
      el.dataset.mcLtInit = '1';

      const elabDays = parseInt(el.dataset.elabDays || '4', 10);

      // Cargar regiones desde el script JSON embebido por Liquid (metafield
      // shop.metafields.malcriados.envio_regiones o las 16 regiones hardcoded
      // como fallback)
      let regions = [];
      const dataEl = el.querySelector('[data-mc-leadtime-regions]');
      if (dataEl) {
        try {
          regions = JSON.parse(dataEl.textContent.trim());
        } catch (err) {
          console.warn('[mc-leadtime] regiones JSON inválido', err);
        }
      }
      if (!Array.isArray(regions) || regions.length === 0) {
        regions = [{ name: 'Chile', min: 3, max: 5 }];
      }

      // Poblar el select
      const selectEl = el.querySelector('[data-mc-leadtime-region]');
      if (selectEl) {
        selectEl.innerHTML = '';
        regions.forEach((r) => {
          const opt = document.createElement('option');
          opt.value = r.name;
          opt.textContent = r.name;
          selectEl.appendChild(opt);
        });

        // Determinar región seleccionada: localStorage > RM > primera
        let stored = '';
        try { stored = localStorage.getItem(MC_REGION_LS_KEY) || ''; } catch (e) {}
        const validStored = regions.find((r) => r.name === stored);
        const rm = regions.find((r) => r.name === MC_REGION_DEFAULT);
        const initial = validStored ? stored : (rm ? rm.name : regions[0].name);
        selectEl.value = initial;

        selectEl.addEventListener('change', () => {
          try { localStorage.setItem(MC_REGION_LS_KEY, selectEl.value); } catch (e) {}
          renderDates(selectEl.value);
        });
      }

      function renderDates(regionName) {
        const r = regions.find((x) => x.name === regionName) || regions[0];
        const minTotal = elabDays + (parseInt(r.min, 10) || 3);
        const maxTotal = elabDays + (parseInt(r.max, 10) || 5);
        const date1 = addBusinessDays(new Date(), minTotal);
        const date2 = addBusinessDays(new Date(), maxTotal);
        const d1El = el.querySelector('.mc-leadtime__date1');
        const d2El = el.querySelector('.mc-leadtime__date2');
        if (d1El) d1El.textContent = formatDateES(date1);
        if (d2El) d2El.textContent = formatDateES(date2);

        // Inyectar el PLAZO RELATIVO como line item property en el carrito.
        //
        // IMPORTANTE: la property NO es una fecha absoluta ("10 de julio al
        // 13 de julio") sino un plazo relativo ("6 y 9 días hábiles desde
        // tu compra"). Antes era fecha absoluta y se congelaba: si el
        // cliente agregaba al carrito un día y compraba días después, la
        // fecha quedaba vieja y generaba reclamos. El plazo relativo nunca
        // se desactualiza porque el cliente lo cuenta desde el día que paga.
        //
        // El PDP (arriba, d1El/d2El) SÍ sigue mostrando la fecha absoluta
        // date1/date2 porque ahí sirve para convertir. Solo lo que se graba
        // en el carrito es relativo. El nombre de la property NO empieza con
        // '_' para que sea visible al cliente y al equipo en cart drawer,
        // checkout y correo de confirmación.
        let propValue;
        if (minTotal === maxTotal) {
          propValue = minTotal + ' días hábiles desde tu compra';
        } else {
          propValue = minTotal + ' y ' + maxTotal + ' días hábiles desde tu compra';
        }
        injectLeadTimeProperty(propValue);
      }

      // Render inicial
      renderDates(selectEl ? selectEl.value : (regions[0] && regions[0].name));
    });
  }
  function addBusinessDays(date, days) {
    const result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) added++; // 0 = domingo, 6 = sábado
    }
    return result;
  }
  function formatDateES(date) {
    const months = [
      'enero','febrero','marzo','abril','mayo','junio',
      'julio','agosto','septiembre','octubre','noviembre','diciembre'
    ];
    return date.getDate() + ' de ' + months[date.getMonth()];
  }

  // Inyecta/actualiza un input hidden con name="properties[Llega entre]"
  // en TODOS los forms de add-to-cart de la página. Esto adjunta la fecha
  // estimada como line item property al item del carrito.
  // - Si el input ya existe, solo actualiza el value (no duplica).
  // - Solo inyecta en forms que apuntan a /cart/add.
  // - Excluye forms que ya tienen un input con name="properties[__mc_pack_pos]"
  //   o "properties[__mc_extra_for_pos]" para NO inyectar en los extras
  //   (jockey upsell, manga bordada, etc.) — solo en el producto principal.
  function injectLeadTimeProperty(value) {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach((form) => {
      // Skip forms de extras (upsells de Malcriados). Esos tienen sus propias
      // properties internas y no necesitan fecha de entrega individual.
      const isExtra = form.querySelector('input[name="properties[__mc_pack_pos]"], input[name="properties[__mc_extra_for_pos]"]');
      if (isExtra) return;

      const existing = form.querySelector('input[name="properties[Llega entre]"]');
      if (existing) {
        existing.value = value;
        return;
      }
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Llega entre]';
      input.value = value;
      form.appendChild(input);
    });
  }

  // -------- Modal guía de tallas --------
  function initTallaModal() {
    const modal = document.querySelector('[data-mc-talla-modal]');
    if (!modal || modal.dataset.mcInit === '1') return;
    modal.dataset.mcInit = '1';

    // Guardar posición original para restaurar al cerrar.
    // CRÍTICO: el modal se mueve al <body> al abrir porque position:fixed
    // se rompe si algún ancestro tiene transform/filter/will-change. Eso
    // convierte al ancestor en el contenedor del fixed, y el modal queda
    // anclado relativo a él en vez del viewport. Moverlo al body lo
    // libera de cualquier ancestor problemático.
    let modalOriginalParent = null;
    let modalOriginalNext = null;

    function openModal() {
      if (modal.parentNode !== document.body) {
        modalOriginalParent = modal.parentNode;
        modalOriginalNext = modal.nextSibling;
        document.body.appendChild(modal);
      }
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }
    function closeModal() {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      // Devolver al lugar original (mantiene la estructura del DOM
      // limpia y permite que Shopify section editor re-inicialice bien)
      if (modalOriginalParent) {
        if (modalOriginalNext && modalOriginalNext.parentNode === modalOriginalParent) {
          modalOriginalParent.insertBefore(modal, modalOriginalNext);
        } else {
          modalOriginalParent.appendChild(modal);
        }
        modalOriginalParent = null;
        modalOriginalNext = null;
      }
    }

    // Listeners de apertura (todos los botones de los slots)
    document.querySelectorAll('[data-mc-talla-modal-open]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openModal();
      });
    });

    // Cierre: overlay, botón ×, ESC
    modal.querySelectorAll('[data-mc-talla-modal-close]').forEach((el) => {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
    });
  }

  // -------- Prendas config: solo listeners de pills/swatches dentro de slots --------
  // (la lógica del tier ahora vive en setTier/initTierSync)
  function initPrendasConfig() {
    document.querySelectorAll('[data-mc-pconfig]').forEach((pconfig) => {
      if (pconfig.dataset.mcInit === '1') return;
      pconfig.dataset.mcInit = '1';

      // Pills + swatches: cambio visual al click + manga toggle
      pconfig.addEventListener('change', (e) => {
        if (e.target.matches('input[type="radio"]')) {
          const fieldset = e.target.closest('.mc-pconfig__option');
          if (fieldset) {
            fieldset.querySelectorAll('.mc-pconfig__pill, .mc-pconfig__swatch').forEach((p) => {
              const i = p.querySelector('input');
              p.classList.toggle('is-active', i && i.value === e.target.value);
            });
            // Actualizar el nombre del valor seleccionado al lado del
            // titulo del legend (data-mc-selected-value). Aplica a
            // cualquier opcion que tenga el span (hoy: Color y Talla).
            const selectedValueSpan = fieldset.querySelector('[data-mc-selected-value]');
            if (selectedValueSpan) selectedValueSpan.textContent = e.target.value;
          }
          // Cuando cambia color o talla en un slot → recalcular stock
          // (afecta visual de las otras tallas/colores del slot)
          updateStockUI(pconfig);
        }
        // Manga checkbox: recalcular total
        if (e.target.matches('[data-mc-extra-slot] input[type="checkbox"]')) {
          const productInfo = pconfig.closest('product-info');
          const variantPrice = productInfo ? readCurrentVariantPrice(productInfo) : 0;
          if (productInfo && variantPrice) updateTotal(productInfo, variantPrice);
        }
      });

      // Init stock visual + re-calcular cuando cambien retratos
      updateStockUI(pconfig);
      const productInfo = pconfig.closest('product-info');
      if (productInfo) {
        const retratosBlock = productInfo.querySelector('[data-mc-retratos-cards]');
        if (retratosBlock) {
          retratosBlock.addEventListener('change', () => {
            setTimeout(() => updateStockUI(pconfig), 50);
          });
        }
      }
    });
  }

  // Calcula visualmente qué tallas/colores están agotados según los
  // retratos seleccionados y, para tallas, según el color del slot.
  function updateStockUI(pconfig) {
    const jsonScript = pconfig.parentElement.querySelector('script[data-mc-variants-json]')
      || document.querySelector('script[data-mc-variants-json]');
    if (!jsonScript) return;
    let variants;
    try {
      variants = JSON.parse(jsonScript.textContent.trim());
    } catch (e) {
      console.warn('[Malcriados] no se pudo parsear variants JSON:', e);
      return;
    }
    if (!variants || !variants.length) return;

    // Leer nombres de las options del producto desde data-product-options
    const optsAttr = pconfig.dataset.productOptions || '';
    const optNames = optsAttr.split('|').filter(Boolean);
    if (!optNames.length) return;

    // Detectar índice de la opción "retratos" (por nombre o regex)
    const retratosIdx = optNames.findIndex((n) => /retrato|cara/i.test(n));
    let retratosValue = null;
    if (retratosIdx >= 0) {
      const productInfo = pconfig.closest('product-info');
      const cardsBlock = productInfo && productInfo.querySelector('[data-mc-retratos-cards]');
      const checked = cardsBlock && cardsBlock.querySelector('input[type="radio"]:checked');
      retratosValue = checked ? checked.value : null;
    }

    // Para cada slot visible, evaluar disponibilidad de cada pill/swatch
    pconfig.querySelectorAll('.mc-pconfig__slot').forEach((slot) => {
      // Estado actual del slot por opción
      const slotState = {};
      slot.querySelectorAll('.mc-pconfig__option').forEach((opt) => {
        const optName = opt.dataset.optionName;
        const checked = opt.querySelector('input[type="radio"]:checked');
        if (optName && checked) slotState[optName] = checked.value;
      });

      // Para cada opción del slot:
      // - TALLA: SIEMPRE disponible (cliente elige primero, no se limita)
      // - COLOR: marcar agotado si no hay variante para esa talla + retratos
      slot.querySelectorAll('.mc-pconfig__option').forEach((opt) => {
        const optName = opt.dataset.optionName;
        const optIdx = optNames.findIndex((n) => normStr(n) === normStr(optName));
        if (optIdx < 0) return;

        const optNameLower = optName.toLowerCase();
        const isTalla = optNameLower.includes('talla') || optNameLower.includes('size');
        const isColor = optNameLower.includes('color');

        opt.querySelectorAll('.mc-pconfig__pill, .mc-pconfig__swatch').forEach((pillOrSwatch) => {
          const input = pillOrSwatch.querySelector('input');
          if (!input) return;

          // TALLAS: siempre disponibles, nunca marcadas como agotadas
          if (isTalla) {
            pillOrSwatch.classList.remove('is-out-of-stock');
            input.disabled = false;
            pillOrSwatch.removeAttribute('aria-disabled');
            pillOrSwatch.removeAttribute('title');
            return;
          }

          const valueOfThis = input.value;
          // COLOR: probar si existe variante disponible con
          //  - retratos = retratosValue (si aplica)
          //  - color = este valor
          //  - talla = la seleccionada del slot
          const isAvailable = variants.some((v) => {
            if (retratosIdx >= 0 && retratosValue) {
              if (normStr(v['option' + (retratosIdx + 1)]) !== normStr(retratosValue)) return false;
            }
            if (normStr(v['option' + (optIdx + 1)]) !== normStr(valueOfThis)) return false;
            // Demás opciones del slot (talla, etc.)
            for (let i = 0; i < optNames.length; i++) {
              if (i === retratosIdx) continue;
              if (i === optIdx) continue;
              const nameI = optNames[i];
              const expectedI = slotState[nameI];
              if (!expectedI) continue;
              if (normStr(v['option' + (i + 1)]) !== normStr(expectedI)) return false;
            }
            return v.available === true;
          });

          pillOrSwatch.classList.toggle('is-out-of-stock', !isAvailable);
          input.disabled = !isAvailable;
          if (!isAvailable) {
            pillOrSwatch.setAttribute('aria-disabled', 'true');
            pillOrSwatch.title = 'No disponible en esta talla';
          } else {
            pillOrSwatch.removeAttribute('aria-disabled');
            pillOrSwatch.removeAttribute('title');
          }
        });

        // Si es la opción COLOR y el actualmente seleccionado no está
        // disponible, cambiar al primer color disponible automáticamente.
        if (isColor) {
          autoFixColorIfUnavailable(opt);
        }
      });
    });
  }

  // Si el color seleccionado del slot está marcado como agotado,
  // cambia al primer color disponible automáticamente.
  function autoFixColorIfUnavailable(colorFieldset) {
    const checked = colorFieldset.querySelector('input[type="radio"]:checked');
    if (!checked) return;
    const checkedSwatch = checked.closest('.mc-pconfig__swatch, .mc-pconfig__pill');
    if (!checkedSwatch || !checkedSwatch.classList.contains('is-out-of-stock')) return;

    // Buscar primer swatch disponible
    const firstAvailable = colorFieldset.querySelector(
      '.mc-pconfig__swatch:not(.is-out-of-stock), .mc-pconfig__pill:not(.is-out-of-stock)'
    );
    if (!firstAvailable) return;
    const newInput = firstAvailable.querySelector('input[type="radio"]');
    if (!newInput) return;
    // Marcar el nuevo + disparar change para que se aplique visual + recalcule
    newInput.checked = true;
    newInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function applyTierToPconfig(productInfo, pconfig, tier) {
    const t = parseInt(tier, 10) || 1;

    // Slot 1 SIEMPRE visible (incluso tier 1 — los mini-forms reemplazan
    // al variant picker original). Slot 2 y 3 según tier.
    pconfig.querySelectorAll('.mc-pconfig__slot').forEach((slot) => {
      const slotNum = parseInt(slot.dataset.slot, 10);
      if (slotNum === 1 || slotNum <= t) {
        slot.removeAttribute('hidden');
      } else {
        slot.setAttribute('hidden', '');
      }
    });

    // Ocultar SIEMPRE el variant_picker original de Color/Talla
    // (los mini-forms son la fuente de verdad para esas opciones).
    // Solo dejamos el de Retratos oculto por su propio mecanismo.
    const fieldsets = productInfo.querySelectorAll('.product-form__input fieldset, fieldset.product-form__input');
    fieldsets.forEach((fs) => {
      const legend = fs.querySelector('legend');
      if (!legend) return;
      const txt = legend.textContent.toLowerCase();
      if (txt.includes('retrato') || txt.includes('cara')) return;
      fs.setAttribute('data-mc-multi-active', '');
    });
    const selects = productInfo.querySelectorAll('.product-form__input select');
    selects.forEach((sel) => {
      const label = productInfo.querySelector('label[for="' + sel.id + '"]');
      if (!label) return;
      const txt = label.textContent.toLowerCase();
      if (txt.includes('retrato') || txt.includes('cara')) return;
      const wrapper = sel.closest('.product-form__input');
      if (wrapper) wrapper.setAttribute('data-mc-multi-active', '');
    });
  }

  // -------- Retratos cards: sync con variant picker + ocultar opción duplicada --------
  function initRetratosCards() {
    document.querySelectorAll('[data-mc-retratos-cards]').forEach((cardsBlock) => {
      const productInfo = cardsBlock.closest('product-info') || document.querySelector('product-info');
      if (!productInfo) return;

      // Aplicar ocultación inicial
      hideRetratosFromVariantPicker(productInfo);

      if (cardsBlock.dataset.mcInit === '1') return;
      cardsBlock.dataset.mcInit = '1';

      // Click en card → seleccionar el radio/option correspondiente del variant picker
      cardsBlock.addEventListener('change', (e) => {
        if (!e.target.matches('input[type="radio"]')) return;
        const value = e.target.value;
        cardsBlock.querySelectorAll('.mc-rcard').forEach((c) => {
          const cInput = c.querySelector('input');
          c.classList.toggle('is-selected', cInput && cInput.value === value);
        });
        triggerVariantPickerChange(productInfo, value);

        // Filtrar extras según retratos compatibles (Jockey solo 2 caras, etc.)
        filterExtrasByRetratos(productInfo);

        // FIX precio de tier cards al cambiar retratos: leer el precio
        // directo del data-variant-price del input checked (ya viene del
        // liquid). No dependemos de Dawn ni del DOM del price block.
        const checkedInput = cardsBlock.querySelector('input[type="radio"]:checked');
        const dataPrice = checkedInput && parseInt(checkedInput.dataset.variantPrice, 10);
        if (dataPrice && !isNaN(dataPrice)) {
          updateTierPrices(productInfo, dataPrice);
          updateTotal(productInfo, dataPrice);
        } else {
          // Fallback DOM si el data attribute no está disponible
          const reapplyPricing = () => {
            const variantPrice = readCurrentVariantPrice(productInfo);
            if (variantPrice) {
              updateTierPrices(productInfo, variantPrice);
              updateTotal(productInfo, variantPrice);
            }
          };
          setTimeout(reapplyPricing, 100);
          setTimeout(reapplyPricing, 350);
          setTimeout(reapplyPricing, 700);
        }
      });

      // MutationObserver: re-aplicar ocultación cuando Dawn re-renderiza el variant picker
      // (esto pasa al cambiar variante — Dawn reemplaza el HTML del fieldset)
      const variantSelector = productInfo.querySelector('variant-selects, variant-radios, .product-form__input');
      const variantPicker = variantSelector ? variantSelector.parentElement : null;
      if (variantPicker && typeof MutationObserver !== 'undefined') {
        const observer = new MutationObserver(() => {
          hideRetratosFromVariantPicker(productInfo);
          // Re-marcar la card activa según la variante actualmente seleccionada
          syncCardSelectionFromVariant(productInfo, cardsBlock);
        });
        observer.observe(variantPicker, { childList: true, subtree: true });
      }

      // También escuchar el evento custom de variant change de Dawn
      productInfo.addEventListener('variant:change', () => {
        setTimeout(() => {
          hideRetratosFromVariantPicker(productInfo);
          syncCardSelectionFromVariant(productInfo, cardsBlock);
        }, 50);
      });

      // Estado inicial: aplicar filtro de extras según retratos seleccionados
      filterExtrasByRetratos(productInfo);
    });
  }

  /**
   * Filtra los extras (Jockey, etc.) según el número de retratos seleccionado.
   * Cada extra puede declarar data-extra-min-retratos / data-extra-max-retratos.
   * Si el valor de retratos actual está fuera del rango, el extra se oculta y
   * se desmarca automáticamente (recalculando el total).
   */
  function filterExtrasByRetratos(productInfo) {
    if (!productInfo) return;
    const retratosVal = getRetratosValue(productInfo);
    const retratosNum = parseInt(retratosVal, 10);
    let needsRecalc = false;

    productInfo.querySelectorAll('[data-mc-extra-slot]').forEach((extraEl) => {
      const min = extraEl.dataset.extraMinRetratos
        ? parseInt(extraEl.dataset.extraMinRetratos, 10) : null;
      const max = extraEl.dataset.extraMaxRetratos
        ? parseInt(extraEl.dataset.extraMaxRetratos, 10) : null;

      // Si el extra no declara filtros, siempre visible
      if (min === null && max === null) {
        extraEl.hidden = false;
        return;
      }

      // Si todavía no hay retratos seleccionados, dejar visible (no filtramos)
      if (!retratosNum || isNaN(retratosNum)) {
        extraEl.hidden = false;
        return;
      }

      const fitsMin = min === null || retratosNum >= min;
      const fitsMax = max === null || retratosNum <= max;
      const compatible = fitsMin && fitsMax;

      if (compatible) {
        extraEl.hidden = false;
      } else {
        extraEl.hidden = true;
        // Si estaba marcado, desmarcarlo y marcar para recalcular total
        const cb = extraEl.querySelector('input[type="checkbox"]');
        if (cb && cb.checked) {
          cb.checked = false;
          needsRecalc = true;
        }
      }
    });

    if (needsRecalc) {
      const variantPrice = readCurrentVariantPrice(productInfo);
      if (variantPrice) updateTotal(productInfo, variantPrice);
    }
  }

  function hideRetratosFromVariantPicker(productInfo) {
    // Fieldsets con legend "Retratos"/"Caras"
    const fieldsets = productInfo.querySelectorAll('.product-form__input fieldset, fieldset.product-form__input');
    fieldsets.forEach((fs) => {
      const legend = fs.querySelector('legend');
      if (!legend) return;
      const txt = legend.textContent.toLowerCase();
      if (txt.includes('retrato') || txt.includes('cara')) {
        fs.setAttribute('data-mc-hidden-by-cards', '');
        // También ocultar el wrapper externo si lo tiene
        const outerWrapper = fs.closest('.product-form__input');
        if (outerWrapper && outerWrapper !== fs) {
          outerWrapper.setAttribute('data-mc-hidden-by-cards', '');
        }
      }
    });
    // Selects (dropdowns) con label "Retratos"/"Caras"
    const selects = productInfo.querySelectorAll('.product-form__input select');
    selects.forEach((sel) => {
      const label = productInfo.querySelector('label[for="' + sel.id + '"]');
      if (!label) return;
      const txt = label.textContent.toLowerCase();
      if (txt.includes('retrato') || txt.includes('cara')) {
        const wrapper = sel.closest('.product-form__input');
        if (wrapper) wrapper.setAttribute('data-mc-hidden-by-cards', '');
      }
    });
  }

  function syncCardSelectionFromVariant(productInfo, cardsBlock) {
    // Buscar qué value está activo en el variant picker original (oculto)
    const hiddenInputs = productInfo.querySelectorAll(
      '[data-mc-hidden-by-cards] input[type="radio"]:checked'
    );
    let activeValue = null;
    hiddenInputs.forEach((r) => { activeValue = r.value; });
    if (!activeValue) {
      const hiddenSelects = productInfo.querySelectorAll(
        '[data-mc-hidden-by-cards] select'
      );
      hiddenSelects.forEach((s) => { activeValue = s.value; });
    }
    if (!activeValue) return;

    // Marcar la card correspondiente
    cardsBlock.querySelectorAll('.mc-rcard').forEach((c) => {
      const cInput = c.querySelector('input');
      const isMatch = cInput && cInput.value === activeValue;
      c.classList.toggle('is-selected', isMatch);
      if (cInput) cInput.checked = isMatch;
    });
  }

  function triggerVariantPickerChange(productInfo, value) {
    // Buscar el input radio o select del variant picker que tenga este valor
    // y disparar el evento change para que Dawn actualice la variante.
    const radios = productInfo.querySelectorAll(
      '.product-form__input[data-mc-hidden-by-cards] input[type="radio"]'
    );
    let found = false;
    radios.forEach((r) => {
      if (r.value === value && !found) {
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
        found = true;
      }
    });
    if (!found) {
      const selects = productInfo.querySelectorAll(
        '.product-form__input[data-mc-hidden-by-cards] select'
      );
      selects.forEach((s) => {
        if (!found) {
          for (let i = 0; i < s.options.length; i++) {
            if (s.options[i].value === value) {
              s.selectedIndex = i;
              s.dispatchEvent(new Event('change', { bubbles: true }));
              found = true;
              break;
            }
          }
        }
      });
    }
  }

  // Hacer que las flechas de la imagen principal naveguen entre thumbs
  // en desktop. Dawn en desktop oculta los items inactivos (display:none),
  // entonces el slider-component nativo no scrollea — hay que disparar el
  // click en el thumb siguiente/anterior para que setActiveMedia cambie
  // cuál item está visible.
  function initMainSliderArrows() {
    document.querySelectorAll('.product__media-wrapper').forEach((wrap) => {
      if (wrap.dataset.mcArrowsInit === '1') return;
      wrap.dataset.mcArrowsInit = '1';

      const mainSlider = wrap.querySelector('media-gallery > slider-component:first-of-type, media-gallery > .product__media-gallery > slider-component:first-of-type');
      const thumbsSlider = wrap.querySelector('.thumbnail-slider, [id^="GalleryThumbnails"]');
      if (!mainSlider || !thumbsSlider) return;

      const buttons = mainSlider.querySelectorAll('.slider-buttons .slider-button');
      if (!buttons.length) return;

      buttons.forEach((btn) => {
        // capture:true → corremos antes que el handler nativo de slider-component
        btn.addEventListener('click', (e) => {
          if (window.innerWidth < 990) return; // mobile usa scroll-snap nativo
          e.preventDefault();
          e.stopPropagation();

          const thumbs = Array.from(thumbsSlider.querySelectorAll('.thumbnail-list__item'));
          if (!thumbs.length) return;

          // Detectar thumb activo via aria-current en su button hijo
          let activeIdx = thumbs.findIndex((t) => t.querySelector('button[aria-current="true"]'));
          if (activeIdx === -1) activeIdx = 0;

          const dir = btn.name === 'next' ? 1 : -1;
          let targetIdx = activeIdx + dir;
          // Loop circular: si pasa el final, vuelve al inicio (y viceversa)
          if (targetIdx >= thumbs.length) targetIdx = 0;
          if (targetIdx < 0) targetIdx = thumbs.length - 1;

          const targetBtn = thumbs[targetIdx].querySelector('button');
          if (targetBtn) targetBtn.click();
        }, { capture: true });
      });
    });
  }

  // Sincronizar altura del aside de iconos con la imagen principal (desktop)
  // Alinea las alturas del .mc-tiercards__sub entre las tier cards
  // del mismo grupo. Mide el sub más alto y aplica a todos → las
  // líneas segmentadas siempre quedan alineadas. Re-corre en resize
  // (cambio de viewport puede cambiar líneas del texto).
  function alignTierCardSubs() {
    document.querySelectorAll('.mc-tiercards').forEach((group) => {
      const subs = group.querySelectorAll('.mc-tiercards__sub');
      if (subs.length < 2) return;
      // Solo aplicar en desktop (≥600px). En mobile las cards se
      // apilan verticales y no necesitan misma altura.
      if (window.innerWidth < 600) {
        subs.forEach((s) => { s.style.minHeight = ''; });
        return;
      }
      // Reset para medir alturas naturales
      subs.forEach((s) => { s.style.minHeight = ''; });
      // Medir el más alto
      let maxH = 0;
      subs.forEach((s) => {
        const h = s.offsetHeight;
        if (h > maxH) maxH = h;
      });
      // Aplicar a todos
      if (maxH > 0) {
        subs.forEach((s) => { s.style.minHeight = maxH + 'px'; });
      }
    });
  }

  // Init + re-correr en resize (debounced)
  let __mcTierAlignRaf;
  function scheduleTierAlign() {
    cancelAnimationFrame(__mcTierAlignRaf);
    __mcTierAlignRaf = requestAnimationFrame(alignTierCardSubs);
  }
  if (typeof window !== 'undefined') {
    window.addEventListener('resize', scheduleTierAlign);
  }

  function syncSideIconsHeight() {
    document.querySelectorAll('.product__media-wrapper').forEach((wrap) => {
      const aside = wrap.querySelector('.mc-side-icons');
      const mediaList = wrap.querySelector('.product__media-list');
      if (!aside || !mediaList || aside.dataset.mcSyncInit === '1') return;
      aside.dataset.mcSyncInit = '1';

      const apply = () => {
        // Desktop ≥990: aplicar altura exacta del media-list al aside
        // (el aside es flex item con flex-start, su altura es natural).
        // Esto hace que los iconos ocupen exactamente la altura de la imagen.
        // Mobile <990: limpiar altura (el grid del wrapper se encarga).
        if (window.innerWidth >= 990) {
          const h = mediaList.getBoundingClientRect().height;
          if (h > 0) aside.style.height = h + 'px';
        } else {
          aside.style.height = '';
        }
      };

      // Aplicar inicial + en cualquier cambio de tamaño
      apply();
      requestAnimationFrame(apply); // segundo frame para imágenes que cargan
      setTimeout(apply, 300);
      setTimeout(apply, 800);

      if (typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(apply);
        ro.observe(mediaList);
      }
      window.addEventListener('resize', apply);

      // Si la primera imagen carga después, recalcular
      const firstImg = mediaList.querySelector('img');
      if (firstImg && !firstImg.complete) {
        firstImg.addEventListener('load', apply, { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
